export const isFeatureEnabled = (featureName) => {
    // Enable onlineUsers and cleanup features by default
    return true;
};
